export const PROD_PROJECT_ID = "doctup-a2cca"
export const PREPROD_PROJECT_ID = "doctup-pre-prod"
export const E2E_PROJECT_ID = "doctup-e2e-test"
